<template>
    <section class="o-page-bottom-spacing--large">
        <page-header>
            <slot slot="title">{{ $t('preorder_fiche.edit') }}</slot>
            <slot slot="description">
                <p>Intro Pre-orders - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum
                    laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales
                    pulvinar tempor.</p>
            </slot>
        </page-header>
        <div class="o-wrapper o-wrapper--center">
            <section class="o-page-row--medium">
                <v-loading :data="PreOrderSheet" custom-class="u-pos-relative"></v-loading>
                <form action="" class="c-form--horizontal o-grid o-grid--half o-gutter-medium">
                    <!-- COLUMN LEFT-->
                    <div :class="{'u-disabled': !PreOrderSheet}">
                        <v-form-row>
                            <v-input v-if="PreOrderSheet.Brand" v-model="PreOrderSheet.Brand.Name" disabled name="merk" :fluid="true"
                                     :error="Validate.Brand">
                                <slot slot="label">{{ $t('preorder_fiche.brand') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-custom-select v-if="PreOrderSheet.Collection"
                                             v-model="PreOrderSheet.Collection"
                                             :options="CollectionOptions"
                                             :error="Validate.Collection"
                                             option-name="Name"
                                             option-value="Id"
                                             name="collectie"
                                             search-label="Name"
                                             track-by="Id"
                                             :fluid="true"
                                             :multiple="false"
                                             :selected="CollectionSelected"
                                             @change="submitForm">
                                <slot slot="label">{{ $t('preorder_fiche.season') }}</slot>
                            </v-custom-select>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="PreOrderSheet.Name"
                                     name="fiche_naam"
                                     :fluid="true"
                                     :error="Validate.Name"
                                     @change="submitForm">
                                <slot slot="label">{{ $t('preorder_fiche.name') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model.number="PreOrderSheet.MaximumDiscount"
                                     name="max_discount"
                                     type="number"
                                     :max=100 :min=0
                                     :disabled="disableDiscount"
                                     :error="Validate.MaximumDiscount"
                                     @change="submitForm">
                                <slot slot="label">{{ $t('preorder_fiche.max_discount') }}</slot>
                                <slot slot="suffix">%</slot>
                            </v-input>
                        </v-form-row>
                    </div>

                    <!-- COLUMN RIGHT -->
                    <div :class="{'u-disabled': !PreOrderSheet}">
                        <v-form-row>
                            <v-select v-model.number="PreOrderSheet.State" :fluid="true" name="status"
                                      :selected="String(PreOrderSheet.State)"
                                      :options="[
                                          {value:'0', content:$t('preorder_fiche.open'), selected: 0 === PreOrderSheet.State ? true : undefined },
                                          {value:'1', content:$t('preorder_fiche.hidden'), selected: 1 === PreOrderSheet.State ? true : undefined },
                                          {value:'2', content:$t('preorder_fiche.closed'), selected: 2 === PreOrderSheet.State ? true : undefined }]"
                                      @input="submitForm">
                                <slot slot="label">{{ $t('preorder_fiche.state') }}</slot>
                            </v-select>
                        </v-form-row>

                        <v-form-row>
                            <v-target-list-select
                                    v-model="PreOrderSheet.Targets"
                                    @change="submitForm">
                            </v-target-list-select>
                        </v-form-row>

                        <v-form-row>
                            <v-datepicker v-model="PreOrderSheet.Deadline"
                                          :label="$t('preorder_fiche.deadline')"
                                          :error="Validate.Deadline"
                                          :fluid="true"
                                          @input="submitForm">
                            </v-datepicker>
                        </v-form-row>

                        <v-form-row>
                            <div class="c-form-item u-pull-right">
                                <router-link to="/admin/pre-orders" class="c-button c-button--outline u-margin-right-small">
                                    {{ $t('global.back') }}
                                </router-link>
                                <button @click.prevent="submitForm" class="c-button c-button--alpha">{{
                                    $t('global.save_changes') }}
                                </button>
                            </div>
                        </v-form-row>
                    </div>
                </form>
            </section>
        </div>

        <!-- CUSTOMER PRODUCTS -->
        <section id="products" class="o-page-row--huge">
            <section :class="loadingProducts ? 'u-disabled o-page-row--medium' : 'o-page-row--medium'">
                <v-filters :center="true" custom-class="u-flex--content-center">
                    <v-product-search :marketingOnly="false"
                            :includePreOrderProducts="true"
                            :preorderSheetId="PreOrderSheet.Id"
                            @add-group-to-sheet="addProductGroupToSheet"
                            @add-product-to-sheet="addProductToSheet">
                    </v-product-search>
                </v-filters>
            </section>

            <div :class="{ 'o-wrapper o-wrapper--center u-pos-relative': true,
                           'u-disabled': loadingProducts }">
                <div class='o-page-row u-flex'>
                    <v-input custom-class="u-inline-block" custom-input-class="u-preordersheet-search" :placeholder="$t('edit_preorder.filter_placeholder')" v-model="searchTerm" name="searchTerm"></v-input>
                    <button @click.prevent="searchPreOrderSheetProducts" class="c-button c-button--alpha c-button--small" title="Zoeken">
                        <svgicon name="search"></svgicon>
                        {{ $t('global.search') }}
                    </button>
                    <button v-if="PreOrderSheetProducts && PreOrderSheetProducts.ProductGroups && PreOrderSheetProducts.ProductGroups.length !== 0"
                            class="u-aria-label-visible u-collapse-all-product-variations c-button c-button--alpha c-button--outline c-button--small u-flex--push-left"
                            @click="collapseAllVariations = !collapseAllVariations"
                            :aria-label="collapseAllVariations ? 'Alles uitklappen' : 'Alles inklappen'">
                    </button>
                </div>

                <v-pagination class="c-pager o-page-row"
                              :config="PaginationConfig"
                              :pagination="PaginationData"
                              @paginated="fetchPaginated"
                ></v-pagination>

                <v-product-line :parent-id="PreOrderSheet.Id" v-for="(group, index) in PreOrderSheetProducts.ProductGroups"
                                :group-index="index" :key="group.Id" :group="group"
                                :collapseAllVariations="collapseAllVariations"
                                @deleted="fetchPreOrderSheetProducts"
                                @sortIndexUpdated="fetchPreOrderSheetProducts">
                </v-product-line>

                <div class="u-font-large u-text-align-center u-padding"
                     v-if="PreOrderSheetProducts && PreOrderSheetProducts.ProductGroups && PreOrderSheetProducts.ProductGroups.length === 0">
                    {{ $t('preorder_fiche.no_products_added') }}<br>
                    <span class="u-font-default">{{ $t('preorder_fiche.use_search') }}</span>
                </div>

                <v-pagination class="c-pager o-page-row"
                              :config="PaginationConfig"
                              :pagination="PaginationData"
                              @paginated="fetchPaginated"
                ></v-pagination>
            </div>
        </section>

        <!-- MARKETING PRODUCTS -->
        <section class="o-page-row--medium">
            <v-filters :center="true" custom-class="u-flex--content-center">
                <v-product-search :marketingOnly="true"
                                :includePreOrderProducts="true"
                                :preorderSheetId="PreOrderSheet.Id"
                                @add-group-to-sheet="addMarketingGroupToSheet"
                                @add-product-to-sheet="addMarketingToSheet">
                    <slot slot="labelText"><span v-html="$t('preorder_fiche.search_marketing')"></span></slot>
                </v-product-search>
            </v-filters>
        </section>

        <div :class="{ 'o-wrapper o-wrapper--center o-page-row--medium is-marketing-line': true,
                       'u-disabled': loadingMarketingProducts || !PreOrderSheetMarketingProducts.MarketingProductGroups.length }">
            <v-marketing-line :parent-id="PreOrderSheet.Id"
                              v-for="(group, index) in PreOrderSheetMarketingProducts.MarketingProductGroups"
                              :group-index="index"
                              :key="group.Id"
                              :group="group"
                              @deleted="fetchPreOrderSheetMarketingProducts">
            </v-marketing-line>
            <div class="u-font-large u-text-align-center u-padding"
                 v-if="PreOrderSheetMarketingProducts && PreOrderSheetMarketingProducts.MarketingProductGroups && PreOrderSheetMarketingProducts.MarketingProductGroups.length === 0">
                {{ $t('preorder_fiche.no_marketing_added') }}<br>
                <span class="u-font-default">{{ $t('preorder_fiche.use_search') }}</span>
            </div>
        </div>

    </section>
</template>

<script>
    import debounce from 'lodash/debounce'
    import PageHeader from '@/components/common/PageHeader'
    import VLoading from '@/components/Loading'
    import VBlocks from '@/components/blocks/Blocks'
    import VChecklist from '@/components/checklist/Checklist'
    import VMarketingProducts from '@/components/product/marketing/MarketingProducts'
    import VPagination from '@/components/Pagination'

    // Forms
    import VTextarea from '@/components/form/Textarea'
    import VInput from '@/components/form/Input'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VSwitch from '@/components/form/Switch'
    import VFilters from '@/components/form/filters/Filters'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VDatepicker from '@/components/form/Datepicker'
    import VTargetListSelect from '@/components/form/targetList/TargetListSelect'
    import VProductSearch from '@/components/form/productSearch/ProductSearch'
    import VProductLine from '@/components/product/admin/ProductLine'
    import VMarketingLine from '@/components/product/admin/MarketingLine'

    // Store
    import {mapGetters} from 'vuex'


    export default {
        components: {
            PageHeader,
            VLoading,
            VSelect,
            VCustomSelect,
            VBlocks,
            VChecklist,
            VTextarea,
            VInput,
            VLabel,
            VDatepicker,
            VTargetListSelect,
            VFormRow,
            VFilters,
            VProductSearch,
            VProductLine,
            VSwitch,
            VMarketingLine,
            VMarketingProducts,
            VPagination
        },
        created: function () {
            this.loadingProducts = true;
            this.loadingMarketingProducts = true;

            // Load preorder data
            this.$store.dispatch('getPreOrderSheet', this.$attrs.id).then(() => {
              this.getCollection(this.PreOrderSheet.Brand.Code);
            });

            // Load preorder products with a limit
            this.$store.dispatch('getPreOrderSheetProducts', {
              id: this.$attrs.id,
              body: {
                PageSize: 10
              }
            }).then(() => {
              this.disableWatch = false
              this.loadingProducts = false
              this.loaded = { loaded: true }
            });

            // Load marketing products
            this.$store.dispatch('getPreOrderSheetMarketingProducts', {
              id: this.$attrs.id,
              body: {
                PageSize: 400
              }
            }).then(() => {
              this.disableWatch = false
              this.loadingMarketingProducts = false
            });
        },
        data() {
            return {
                disableWatch: true,
                disableDiscount: false,
                Validate: {},
                collapseAllVariations: false,
                sendMaximumDiscount: false,
                loaded: {},
                loadingProducts: false,
                loadingMarketingProducts: false,
                Page: 1,
                searchTerm: ''
            }
        },
        computed: {
            ...mapGetters({
                PreOrderSheet: 'PreOrderSheet',
                PreOrderSheetProducts: 'PreOrderSheetProducts',
                PreOrderSheetMarketingProducts: 'PreOrderSheetMarketingProducts',
                CollectionOptions: 'CollectionOptions'
            }),
            CollectionSelected() {
                return this.CollectionOptions.find((option) => {
                    return this.PreOrderSheet.Collection.Id === option.Id
                });
            },
            PaginationData() {
              return {
                PageStartIndex: this.PreOrderSheetProducts.PageStartIndex,
                PageEndIndex: this.PreOrderSheetProducts.PageEndIndex,
                PageLastIndex: this.PreOrderSheetProducts.PageCount,
                TotalCount: this.PreOrderSheetProducts.TotalCount,
                Pages: this.PreOrderSheetProducts.Pages,
                PageCount: this.PreOrderSheetProducts.PageCount
              }
            },
            PaginationConfig() {
              return {
                Page: this.Page
              }
            }
        },
        watch: {
            "PreOrderSheet.MaximumDiscount"() {
                if (!this.disableWatch) {
                    this.sendMaximumDiscount = true;
                }
            }
        },
        methods: {
            fetchPage() {
                this.$store.dispatch('getPreOrderSheet', this.PreOrderSheet.Id);
            },
            getCollection(value) {
                this.$store.dispatch('getCollectionsOptions', {Id: value});
            },

            // SUBMIT SHEET INFO
            submitForm: debounce(function () {
                if (this.sendMaximumDiscount) {
                    this.disableDiscount = true;
                }

                if (!this.disableWatch) {
                    this.$store.dispatch('updatePreOrderSheet', {
                        Id: this.PreOrderSheet.Id,
                        PreOrderSheet: this.PreOrderSheet
                    }).then((response) => {
                        if (response.status > 300 && response.data.ModelState) {
                            this.setValidation(response.data.ModelState);
                        } else {
                            if (this.sendMaximumDiscount) {
                                this.disableWatch = true;
                                this.fetchPage();
                                this.sendMaximumDiscount = false;
                                this.disableDiscount = false;
                            }
                            this.notifyUser(this.$t('global.saved'), 'success');
                            this.Validate = {};
                        }
                    });
                } else {
                    this.disableWatch = false;
                }
            }, 500),

            // NOTIFY USER
            notifyUser(title, type = 'success') {
                this.$notify({
                    group: 'global',
                    title: title,
                    type: type,
                    duration: 2000
                });
            },

            // SET VALIDATION
            setValidation(errors) {
                Object.keys(errors).forEach(function (key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.' + key][0];
                    delete errors['model.' + key];
                });

                this.Validate = errors;
            },

            // PRODUCTS
            addProductGroupToSheet(productGroupId) {
                this.$store.dispatch('sendGroupToSheet', {
                    preOrderSheetId: this.PreOrderSheet.Id,
                    productGroupId: productGroupId
                }).then(() => {
                    this.fetchPreOrderSheetProducts();
                    this.notifyUser('Groep toegevoegd.');
                });
            },
            addProductToSheet(productId, productGroupId) {
                this.$store.dispatch('sendProductToSheet', {
                    preOrderSheetId: this.PreOrderSheet.Id,
                    productId: productId,
                    productGroupId: productGroupId
                }).then(() => {
                    this.fetchPreOrderSheetProducts();
                    this.notifyUser('Product toegevoegd.');
                });
            },

            // MARKETING
            addMarketingGroupToSheet(marketingGroupId) {
                this.$store.dispatch('sendMarketingGroupToSheet', {
                    preOrderSheetId: this.PreOrderSheet.Id,
                    productGroupId: marketingGroupId
                }).then(() => {
                    this.fetchPreOrderSheetMarketingProducts();
                    this.notifyUser('Marketing groep toegevoegd.');
                });
            },
            addMarketingToSheet(productId, productGroupId) {
                this.$store.dispatch('sendMarketingToSheet', {
                    preOrderSheetId: this.PreOrderSheet.Id,
                    productId: productId,
                    productGroupId: productGroupId
                }).then(() => {
                    this.fetchPreOrderSheetMarketingProducts();
                    this.notifyUser('Marketing product toegevoegd.');
                });
            },
            searchPreOrderSheetProducts() {
                this.fetchPreOrderSheetProducts();
            },
            fetchPreOrderSheetProducts() {
              this.loadingProducts = true;
              this.loaded = {};

              this.$store.dispatch('getPreOrderSheetProducts', {
                id: this.$attrs.id,
                body: {
                  Page: this.Page,
                  PageSize: 10,
                  Search: this.searchTerm
                }
              }).then(() => {
                this.loadingProducts = false;
                this.loaded = { loaded: true }
              }).catch(() => {
                this.loadingProducts = false;
                this.loaded = { loaded: true }
              })
            },
            fetchPaginated(config) {
                this.scrollToProductTop();

                this.Page = config.Page;
                this.fetchPreOrderSheetProducts();
            },
            scrollToProductTop() {
                var options = {
                    container: 'body',
                    easing: 'ease-in',
                    offset: -60,
                    cancelable: true,
                    onStart: function(element) { },
                    onDone: function(element) { },
                    onCancel: function() { },
                    x: false,
                    y: true
                }
                var cancelScroll = this.$scrollTo("#products", 500, options);
            },
            fetchPreOrderSheetMarketingProducts() {
              this.loadingMarketingProducts = true;
              this.loaded = {};

              this.$store.dispatch('getPreOrderSheetMarketingProducts', {
                id: this.$attrs.id,
                body: {
                  PageSize: 400
                }
              }).then(() => {
                this.loadingMarketingProducts = false;
                this.loaded = { loaded: true }
              }).catch(() => {
                this.loadingMarketingProducts = false;
                this.loaded = { loaded: true }
              })
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .u-collapse-all-product-variations {
        top: -33px;
        min-width: 150px;
        height: 32px;
    }
</style>

<style lang="scss">
    .u-preordersheet-search {
        min-width: 270px;
    }
</style>


// WEBPACK FOOTER //
// src/views/admin/preOrders/Edit.vue